import chartConfigGenerator from './chartConfigGenerator';
import shipmentCountGenerator from './dataSourceGenerators/shipmentCountGenerator';
import billAmountGenerator from './dataSourceGenerators/billAmountGenerator';
import deliveryDelayGenerator from './dataSourceGenerators/deliveryDelayGenerator';
import billRateGenerator from './dataSourceGenerators/billRateGenerator';
import totalShipmentText from './dataSourceGenerators/totalShipmentText';
import billAmountText from './dataSourceGenerators/billAmountText';
import avgBillRateText from './dataSourceGenerators/avgBillRateText';
import volumnShipmentCount from './dataSourceGenerators/volumnShipmentCount';
import avgBillForCutomer from './dataSourceGenerators/avgBillForCutomer';
import shipmentDelayDistribution from './dataSourceGenerators/shipmentDelayDistribution';
import avgShipmentDelay from './dataSourceGenerators/avgShipmentDelay';
import avgDelayForCustomers from './dataSourceGenerators/avgDelayForCustomers';
import usaMapGenerator from '../util/dataSourceGenerators/usaMapGenerator';
import usaMapSecondGenerator from '../util/dataSourceGenerators/usaMapSecondGenerator';
import usaMapThirdGenerator from '../util/dataSourceGenerators/usaMapThirdGenerator';
import TimeRange from './getTimeRange.js';
import {CustomerTabLoader, DelayTabLoader, KpiLoader, KpiLoaderSecond} from './loader';

export {
    chartConfigGenerator,
    shipmentDelayDistribution,
    avgShipmentDelay,
    avgDelayForCustomers,
    shipmentCountGenerator,
    billAmountGenerator,
    deliveryDelayGenerator,
    billRateGenerator,
    totalShipmentText,
    billAmountText,
    avgBillRateText,
    volumnShipmentCount,
    avgBillForCutomer,
    usaMapGenerator,
    usaMapSecondGenerator,
    usaMapThirdGenerator,
    CustomerTabLoader,
    DelayTabLoader,
    KpiLoader,
    KpiLoaderSecond,
    TimeRange
}


// WEBPACK FOOTER //
// ./src/util/index.js